import { BaseInitialState } from 'src/types'

export const unselectedState = { label: '未選択', value: 'unselected' }
export const unselectedStateWithPrice = { label: '未選択', value: 'unselected', price: 0 }
export const unselectedColorState = { label: '未選択', value: 'unselected', color: '#fff' }
export const unselectedStateEn = { label: 'Unselected', value: 'unselected' }
export const unselectedColorStateEn = { label: 'Unselected', value: 'unselected', color: '#fff' }
export const unselectedStateKo = { label: '미선택', value: 'unselected' }
export const unselectedColorStateKo = { label: '미선택', value: 'unselected', color: '#fff' }
export const unselectedStateWithPriceKo = { label: '미선택', value: 'unselected', price: 0 }

export const baseInitialState: BaseInitialState = {
  // トップページのloading
  isLoading: false,
  backStyle: unselectedState,
  dominantArm: unselectedState,
  size: unselectedState,
  fingerGuardType: unselectedState,
  baseModel: {
    productNumber: '',
    imageUrl: '',
    dominantArm: 'unselected',
    position: '',
    size: 0,
    webParts: '',
    description: '',
    series: '',
    backStyle: '',
    imageWidth: 0,
    imageHeight: 0
  }
}

export const baseInitialStateEn: BaseInitialState = {
  // トップページのloading
  isLoading: false,
  backStyle: unselectedStateEn,
  dominantArm: unselectedStateEn,
  size: unselectedStateEn,
  fingerGuardType: unselectedStateEn,
  baseModel: {
    productNumber: '',
    imageUrl: '',
    dominantArm: 'unselected',
    position: 'infielder', // 本当はここ、infielderでありたくない
    size: 0,
    webParts: '',
    description: '',
    series: '',
    backStyle: '',
    imageWidth: 0,
    imageHeight: 0
  }
}

export const baseInitialStateKo: BaseInitialState = {
  // トップページのloading
  isLoading: false,
  backStyle: unselectedStateKo,
  dominantArm: unselectedStateKo,
  size: unselectedStateKo,
  fingerGuardType: unselectedStateKo,
  baseModel: {
    productNumber: '',
    imageUrl: '',
    dominantArm: '미선택',
    position: 'infielder', // 本当はここ、infielderでありたくない
    size: 0,
    webParts: '',
    description: '',
    series: '',
    backStyle: '',
    imageWidth: 0,
    imageHeight: 0
  }
}

export const colorInitialState = {
  parts: { label: '全体', value: 'all' },
  all: unselectedColorState,
  catchFace: unselectedColorState,
  edge: unselectedColorState,
  lace: unselectedColorState,
  linings: unselectedColorState,
  hamidashi: unselectedColorState,
  listLiningsMaterial: unselectedColorState,
  stitch: { label: '未選択', value: 'unselected', color: '#eee' },
  web: unselectedColorState,
  web2: unselectedColorState,
  thumbHook: unselectedColorState,
  littleHook: unselectedColorState,
  listBelt: unselectedColorState,
  indexCover: unselectedColorState
}

export const colorInitialStateEn = {
  parts: { label: 'Over All', value: 'all' },
  all: unselectedColorStateEn,
  catchFace: unselectedColorStateEn,
  edge: unselectedColorStateEn,
  lace: unselectedColorStateEn,
  linings: unselectedColorStateEn,
  hamidashi: unselectedColorStateEn,
  listLiningsMaterial: unselectedColorStateEn,
  stitch: { label: 'Unselected', value: 'unselected', color: '#eee' },
  web: unselectedColorStateEn,
  web2: unselectedColorStateEn,
  thumbHook: unselectedColorStateEn,
  littleHook: unselectedColorStateEn,
  listBelt: unselectedColorStateEn,
  indexCover: unselectedColorStateEn
}

export const colorInitialStateKo = {
  parts: { label: '전체', value: 'all' },
  all: unselectedColorStateKo,
  catchFace: unselectedColorStateKo,
  edge: unselectedColorStateKo,
  lace: unselectedColorStateKo,
  linings: unselectedColorStateKo,
  hamidashi: unselectedColorStateKo,
  listLiningsMaterial: unselectedColorStateKo,
  stitch: { label: '미선택', value: 'unselected', color: '#eee' },
  web: unselectedColorStateKo,
  web2: unselectedColorStateKo,
  thumbHook: unselectedColorStateKo,
  littleHook: unselectedColorStateKo,
  listBelt: unselectedColorStateKo,
  indexCover: unselectedColorStateKo
}

// 投・内・外で使うカラー情報
export const gloveColorInitialState = {
  thumbOut: unselectedColorState,
  thumbWeb: unselectedColorState,
  thumbRoot: unselectedColorState,
  indexWeb: unselectedColorState,
  indexMiddle: unselectedColorState,
  middleIndex: unselectedColorState,
  middleRing: unselectedColorState,
  ringMiddle: unselectedColorState,
  ringLittle: unselectedColorState,
  littleRing: unselectedColorState,
  littleOut: unselectedColorState
}

export const initialEmbroideryState = {
  id: 0,
  typeFace: { label: '', value: '' },
  position: { label: '', value: '' },
  color: { label: '未選択', value: 'unselected', color: '' },
  shadowColor: { label: '未選択', value: 'unselected' },
  edgeColor: { label: '未選択', value: 'unselected' },
  content: ''
}

export const initialPersonalState = {
  userName: '',
  userNameKana: '',
  phoneNumber: '',
  mailAddress: '',
  league: '',
  position: '',
  remarks: ''
}

export const initialGloveImagesState = {
  front: '',
  rear: ''
}

export const emojiMatch =
  /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|[\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|[\ud83c[\ude32-\ude3a]|[\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g

export const REQUEST_HEADERS = {
  headers: {
    // prettier-ignore
    'Accept': 'application/json, text/plain, */*',
    'Content-Type': 'application/json'
  }
}

export const watchFormDefaultValue = {
  defaultValues: {
    mailAddress: '',
    mailAddress2: ''
  }
}
